import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import { useAssetActions } from 'asset-actions-lib/context/AssetActionsContext';
import { useGetSubscriptionsQuery } from '../../../__generated__/chirp/com/hubspot/esp/sync/rpc/FormSubscriptionsRpc.hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export default function EditNonHSMailchimpListActionButton(props) {
  var _data$subscriptions;
  const {
    crmObject
  } = useAssetActions();
  const formGuid = getPropertyValue(crmObject, 'hs_form_id') || '';
  const {
    data,
    loading
  } = useGetSubscriptionsQuery({
    variables: {
      formGuid
    }
  });
  const subscriptionCount = ((_data$subscriptions = data === null || data === void 0 ? void 0 : data.subscriptions) !== null && _data$subscriptions !== void 0 ? _data$subscriptions : []).filter(subscription => subscription.syncEnabled).length;
  return /*#__PURE__*/_jsx(Button, Object.assign({}, props, {
    children: loading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      size: "extra-small",
      layout: "centered"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "assetActionsLibForms.actions.editMailchimpLists",
      options: {
        count: subscriptionCount
      }
    })
  }));
}